import styles from './DashboardLoader.module.scss';

const DashboardLoader = () => (
  <div className={styles.loaderContainer} role="status" aria-live="polite">
    <div className={styles.badge} aria-hidden="true">
      <span className={styles.ring} />
      <span className={styles.pulse} />
    </div>
    <p className={styles.message}>
      Setting up your dashboard
      <span className={styles.dots} aria-hidden="true">
        <i />
        <i />
        <i />
      </span>
    </p>
  </div>
);

export default DashboardLoader;
